import request from "@/utils/request";

export default function getAgentDeviceByPage(params, pageNum = 1, size = 10,) {
    return request({
        url: `/device/device/getAgentDeviceByPage/${pageNum}/${size}`,
        params: params
    })
}
